import { createUserInmail } from '@/pages/api/scribeAPIV2';
import { type CreateUserInmailRequest } from '@/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_NOTIFICATIONS } from '../query/useQueryNotifications';

export const useCreateNotification = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (inmail: CreateUserInmailRequest) => {
      const { data } = await createUserInmail(inmail);
      return data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [GET_NOTIFICATIONS] });
    },
  });
};
